import { render, staticRenderFns } from "./ConfigurationPremappedLineItemMappings.vue?vue&type=template&id=5053d998&"
import script from "./ConfigurationPremappedLineItemMappings.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPremappedLineItemMappings.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationPremappedLineItemMappings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports